import React, { useRef } from "react";
import { useRemoteComponents } from "./internal/use-remote-components.js";
export function createDrawerLoader({ Fallback }) {
    return function DrawerLoader(props) {
        const ref = useRef(null);
        const components = useRemoteComponents(ref, { Drawer: Fallback });
        return components.Drawer ? React.createElement(components.Drawer, { ...props }) : React.createElement("div", { ref: ref });
    };
}
